// @flow
import * as React from "react"
import ArrowIcon from "assets/icons/ArrowIcon"
import { BackLink } from "./styled"

type Props = {|
  children: React.Node,
  to: string,
  withFilter?: boolean,
|}

const ArrowLink = ({ children, ...rest }: Props) => (
  <BackLink {...rest}>
    <ArrowIcon rotation="left" />
    <span>{children}</span>
  </BackLink>
)

export default ArrowLink



// WEBPACK FOOTER //
// ./src/pages/_Page/SubPage/BackButton/index.js